import { render, staticRenderFns } from "./aboutSetting.vue?vue&type=template&id=19d3a495"
import script from "./aboutSetting.vue?vue&type=script&lang=js"
export * from "./aboutSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports